import { NavigationContainer } from "@/components/NavigationButton";
import { graphql } from "@/config/graphql";
import { safeNumber } from "@/utils/number";
import { useMutation, useQuery } from "@apollo/client";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Box,
  CircularProgress,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { z } from "zod";

const Header = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
`;
const Form = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

const setCommentToReportQuery = graphql(`
  mutation setCommentToReport($params: SetCommentToReportParams!) {
    setCommentToReport(params: $params) {
      id
      comments
    }
  }
`);
const currentCommentQuery = graphql(`
  query currentComment($params: ReportParams!) {
    report(params: $params) {
      id
      comments
    }
  }
`);

const commentReportSchema = z.object({
  comment: z.string(),
});
type CommentReportSchema = z.infer<typeof commentReportSchema>;
export const ReportComment = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data } = useQuery(currentCommentQuery, {
    variables: {
      params: {
        id: safeNumber(params.id),
      },
    },
  });
  const [setCommentToReport, { loading }] = useMutation(
    setCommentToReportQuery
  );
  const { control, handleSubmit, setValue } = useForm<CommentReportSchema>({
    resolver: zodResolver(commentReportSchema),
    defaultValues: {
      comment: data?.report.comments ?? undefined,
    },
  });

  const onSubmit = async (data: CommentReportSchema) => {
    await setCommentToReport({
      variables: {
        params: {
          reportId: safeNumber(params.id),
          comment: data.comment,
        },
      },
    });
  };

  const goBack = () => navigate(`/formulario-reporte/${params.id}/transporte`);
  const goNext = async () => {
    await handleSubmit(onSubmit)();
    navigate(`/formulario-reporte/${params.id}/resumen`);
  };

  useEffect(() => {
    if (!data?.report.comments) return;
    setValue("comment", data?.report.comments);
  }, [data?.report.comments, setValue]);
  return (
    <div>
      <Header>
        <Typography variant="h6">Comentarios</Typography>
      </Header>
      <Form>
        <Controller
          name="comment"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              label="Notas"
              multiline
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              focused
              {...field}
            ></TextField>
          )}
        />
      </Form>
      <NavigationContainer
        handleNext={goNext}
        handlePrev={goBack}
        nextComponent={
          <>
            VER RESUMEN{" "}
            {loading && <CircularProgress size={20} sx={{ marginLeft: 1 }} />}
          </>
        }
      />
    </div>
  );
};
